import React from 'react';
import { motion } from 'framer-motion';
import SettingsSuggestOutlinedIcon from '@mui/icons-material/SettingsSuggestOutlined';
import { FadeIn } from './FadeIn';
import { SectionHeader } from './SectionHeader';
import { AnimatedBackground } from './AnimatedBackground';
import { processSteps } from '../data/process';
export function Process() {
  return <section id="proceso" className="cv-auto relative w-full overflow-hidden bg-brand-deep px-6 py-24" data-id="element-281" data-mp="23c7axxjp7153">
      <AnimatedBackground intensity="soft" icons data-id="element-282" data-mp="1apm9u5df7aoc" />

      <div className="relative mx-auto max-w-[1100px]" data-id="element-283" data-mp="1aqfg758gvy5y">
        <FadeIn data-id="element-284" data-mp="1foz61gq6lu3l">
          <SectionHeader dark centered badge="Proceso" badgeIcon={<SettingsSuggestOutlinedIcon sx={{
          fontSize: 15
        }} data-id="element-286" data-mp="1kfpex3xtgf31" />} title={<>
                Tu web lista en
                <br data-id="element-287" data-mp="mzrzpvkhk07s" />
                <span className="text-brand-yellow" data-id="element-288" data-mp="rz4vx6x8yjn1">4 pasos simples.</span>
              </>} subtitle="Yo me encargo de todo. Tú solo apruebas y recibes clientes." data-id="element-285" data-mp="1fogznr9t1zhy" />
        </FadeIn>

        <div className="relative grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-289" data-mp="15jw4u5xw4ddm">
          <motion.div aria-hidden="true" initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true,
          amount: 0.5
        }} transition={{
          duration: 1.2,
          ease: [0.16, 1, 0.3, 1]
        }} className="absolute left-[10%] right-[10%] top-7 hidden h-0.5 origin-left bg-[linear-gradient(90deg,#FFD500,#1B4DCC,#FFD500)] lg:block" data-id="element-290" data-mp="10sxjgry1op3i" />

          {processSteps.map((step, index) => <motion.div key={step.number} initial={{
          opacity: 0,
          y: 26
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 0.6,
          delay: 0.25 + index * 0.12,
          ease: [0.16, 1, 0.3, 1]
        }} className="group relative z-10 text-center" data-id="element-291" data-mp="hul7yzjnv34r" data-mpi={index}>
              <motion.div whileHover={{
            scale: 1.1,
            rotate: -4
          }} transition={{
            type: 'spring',
            stiffness: 300,
            damping: 16
          }} className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-brand-yellow font-display text-[22px] font-extrabold text-brand-deep shadow-[0_0_0_4px_#071F5C,0_0_0_6px_#FFD500]" data-id="element-292" data-mp="2v4bawvl175te">
                {step.number}
              </motion.div>
              <h3 className="mb-2 font-display text-base font-bold text-white" data-id="element-293" data-mp="3e1w0k4vme8f2">
                {step.title}
              </h3>
              <p className="text-[13px] leading-relaxed text-white/65" data-id="element-294" data-mp="305iiatj9i2zj">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}